// extracted by mini-css-extract-plugin
export default {"propertyList":"properties-listing_propertyList__vsbTo","content":"properties-listing_content__C+T06"};